import { getH5BackButtonIconSrc } from "./H5BackButtonConfig";
import "./H5BackButton.css";

type Props = {
  className?: string;
  iconClassName?: string;
  onClick: () => void;
  "aria-label"?: string;
};

/** 全 H5 统一返回按钮（图标地址与尺寸见 H5BackButtonConfig.ts） */
export function H5BackButton(props: Props) {
  const { className, iconClassName, onClick, "aria-label": ariaLabel = "返回" } = props;
  const btnClass = ["h5-back-button", className].filter(Boolean).join(" ");
  const iconClass = ["h5-back-button__icon", iconClassName].filter(Boolean).join(" ");
  return (
    <button type="button" className={btnClass} onClick={onClick} aria-label={ariaLabel}>
      <img src={getH5BackButtonIconSrc()} alt="" className={iconClass} />
    </button>
  );
}
